<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount } from 'vue'
import CustomList from "../../../compositions/CustomList.vue";
import ModalDialog from "../../../compositions/ModalDialog.vue";
import SearchBox from "../../../compositions/SearchBox.vue";
import CheckBox from "../../../compositions/CheckBox.vue";
import config from "../../../config.js";
import { errorAlert,confirmAlert,successAlert } from "../../../plugins/alert";
import qs from 'qs';
import axios from '../../../plugins/axios.ts';
import { getFieldValue } from "../../../plugins/utility";
import HelpAction from '../../../compositions/HelpAction.vue';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    currentPharmacy:{
      type:Object,
      required:true,
    },
})
const listRef = ref();
const listHeight = ref(72);
const headerRef = ref();
const submitRef = ref();
const headPharmacyMedicineList = reactive([]);
const headPharmacyMedicineDefaultList = reactive([]);
const isLoadingDialog = ref(false);
const changeListHeight = () => {
  if (typeof headerRef.value !== 'undefined') {
    listHeight.value = window.innerHeight - document.getElementById('header').clientHeight - document.getElementById('footer').clientHeight - headerRef.value.clientHeight - 5;
    if (typeof submitRef.value !== 'undefined' && isManagedMode.value) {
      listHeight.value -= (submitRef.value.clientHeight - document.getElementById('footer').clientHeight - 5);
    }
    if (listHeight.value < 200) {
      listHeight.value = 200;
    }
  }
}
const searchWord = ref('');
const isHeadManaged = ref(false);
const onChangeHeadManaged = (value) => {
  isHeadManaged.value = value;
  listSearch();
}
const isManagedMode = ref(false);
const onChangeManagedMode = (value) => {
  changeListHeight();
  isManagedMode.value = value;
}
const onSearchWordChange = (value) => {
  searchWord.value = value;
}
const onSearchWordEnter = (value) => {
  searchWord.value = value;
  listSearch();
}
const listSearch = (delay=0) => {
  headPharmacyMedicineDefaultList.splice(0);
  optionFields.value.search_word = searchWord.value;
  optionFields.value.is_head_managed = (isHeadManaged.value ? 1 : null);
  listRef.value.resetItem(delay);
}
const onHeadPharmacyMedicineCheckChange = (values) => {
  headPharmacyMedicineList.splice(0);
  for (let i=0;i<values.length;i++) {
    headPharmacyMedicineList.push(values[i]);
  }
}
const responseComplete = (data) => {
  for (let i=0;i<data.list.length;i++) {
    if (data.list[i].is_head_managed) {
      headPharmacyMedicineDefaultList.push(data.list[i].medicine_id);
      headPharmacyMedicineList.push(data.list[i].medicine_id);
    }
  }
}
const optionFields = ref({
  'page_size' : 30,
  'search_word': searchWord.value,
  'is_head': 1,
  'is_head_pharmacy_medicine':1,
  'is_head_managed':null,
});
const fields = ref([
  {field_name: '管理品', field_key: 'is_head_managed', width: '5%', align: 'text-center', sorted:true},
  {field_name: '採用品', field_key: 'product_detail_name', width: '15%', align: 'text-left', sorted:true},
  {field_name: '経過措置', field_key: 'transitional_measure_date', width: '8%', align: 'text-center', sorted:true},
  {field_name: '分類', field_key: 'warning_mark', width: '6%', align: 'text-center', sorted:true},
  {field_name: '販売元', field_key: 'seller_name', width: '10%', align: 'text-left', sorted:true},
  {field_name: 'コード', field_key: 'medicine_code_info', width: '10%', align: 'text-left', sorted:false},
]);

const resetHeadPharmacyMedicineList = () => {
    isManagedMode.value = false;
    headPharmacyMedicineList.splice(0);
}
const updateHeadPharmacyMedicineManaged = async () => {
  isLoadingDialog.value = true;
  let params = {
    'select_list':headPharmacyMedicineList,
    'delete_list':[],
  };
  for (let i=0;i<headPharmacyMedicineDefaultList.length;i++) {
    if (headPharmacyMedicineList.indexOf(headPharmacyMedicineDefaultList[i]) == -1) {
      params['delete_list'].push(headPharmacyMedicineDefaultList[i]);
    }
  }
  try {
    const response = await axios(props.apis.head_pharmacy_medicine_managed_update,{method:"post",data:params});
    if (response.data.status == 200) {
      successAlert('予約しました。しばらくお待ちください。');
      resetHeadPharmacyMedicineList();
      listSearch(1000);
    }
  } finally {
    isLoadingDialog.value = false;
  }
  //
}
const cancelHeadPharmacyMedicineManagedConfirmed = async () => {
  let result = await confirmAlert('現在編集中のデータが消えますがよろしいですか？');
  if (result.isConfirmed) {
    resetHeadPharmacyMedicineList();
  }
}
onBeforeUnmount(() => {
  window.removeEventListener('resize', changeListHeight);
})
onMounted(() => {
  window.addEventListener('resize', changeListHeight);
  setTimeout(changeListHeight,100);
});
</script>

<style scoped>
</style>
<template>
<div ref="element" class="relative">
  <div class="absolute top-2 left-2">
    <help-action
      help-key="head_pharmacy_medicine_help"
    ></help-action>
  </div>
  <div ref="headerRef" class="w-full flex items-center justify-between p-2 bg-gray-100 rounded">
      <div class="ml-8">
        <check-box
        label="管理品で絞り込む"
        :value="isHeadManaged"
        :on-change="onChangeHeadManaged"
        ></check-box>
      </div>
      <div class="flex items-center flex-row">
        <div class="mb-2 mt-1">
          <search-box
            :search-word="searchWord"
            :on-change="onSearchWordChange"
            :on-enter="onSearchWordEnter"
            place-holder="商品名を入力"
        ></search-box>
        </div>
        <div class="m-1">
          <a href="javascript:void(0)" @click="onChangeManagedMode(true)" class="text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200 block font-medium rounded-lg text-xs md:text-base px-4 py-1 w-full sm:w-auto text-center ml-2">管理品選択</a>
        </div>
      </div>
  </div>
  <div class="w-full">
      <custom-list
        ref="listRef"
        :table-fields="fields"
        :api-url="apis.pharmacy_medicine_list"
        :option-fields="optionFields"
        :is-checkable="isManagedMode"
        :is-all-check="false"
        :height="listHeight + 'px'"
        list-key="medicine_id"
        :response-complete="responseComplete"
        :check-values="headPharmacyMedicineList"
        :on-check-change="onHeadPharmacyMedicineCheckChange"
      >
      <template v-slot:item="slotProps">
        <td v-for="(field,index) in fields" :style="'width:' + field.width" :class="field.align">
          <div v-if="field.field_key == 'warning_mark'" :class="field.align">
            <span v-html="slotProps.item.warning_mark"></span>
          </div>
          <div v-else-if="field.field_key == 'is_head_managed'" :class="field.align">
            <span class="text-red-600">{{ slotProps.item.is_head_managed ? '〇' : '' }}</span>
          </div>
          <div v-else-if="field.field_key == 'medicine_code_info'" :class="field.align">
            <div>JANコード:{{ (slotProps.item.jan_code ? slotProps.item.jan_code : '') }}</div>
            <div>包装コード:{{ (slotProps.item.dispensing_packaging_unit_code ? slotProps.item.dispensing_packaging_unit_code : '') }}</div>
            <div>販売コード:{{ (slotProps.item.sales_packaging_unit_code ? slotProps.item.sales_packaging_unit_code : '') }}</div>
          </div>
          <div v-else :class="field.align">
            {{ getFieldValue(slotProps.item,field.field_key) }}
          </div>
        </td>
      </template>
      </custom-list>
  </div>
  <div ref="submitRef" v-show="isManagedMode" class="fixed bottom-0 right-0 w-full flex items-center justify-end flex-wrap p-2 bg-gray-100 rounded">
    <div class="mr-2"><button type="button" @click="updateHeadPharmacyMedicineManaged" class="w-full py-2 px-2 text-xs font-medium text-white focus:outline-none bg-red-600 rounded-full border border-red-200 hover:bg-red-700 hover:text-white focus:z-10 focus:ring-4 focus:ring-red-200 dark:focus:ring-red-700 dark:bg-red-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 mr-1">更新する</button></div>
    <div><button type="button" @click="cancelHeadPharmacyMedicineManagedConfirmed()" class="w-full py-2 px-2 text-xs font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">キャンセルする</button></div>
  </div>
</div>
<modal-dialog
  :is-visible="isLoadingDialog"
  width="40%"
  :isLoading="true"
>
  <template v-slot:header>
  </template>
  <template v-slot:default>
  <div class="mb-6">
    処理中です。
  </div>
  </template>
</modal-dialog>
</template>

